import React, { useRef } from 'react'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

import { Dialog, Icon, Transition } from 'src/chrome'
import { useScroll, useState } from 'src/hooks'

import styles from './shareContact.module.scss'
import { CircularProgress, DialogTitle } from '@material-ui/core'
import DialogContent from '@material-ui/core/DialogContent'
import {
  Button,
  HStack,
  Input,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'
import { useInfiniteMinimalContacts } from 'src/react_query'

type Props = {
  contactsIds: string[]
  onSubmit: (username: string) => void
  onClose?: () => void
}

const ShareContact: React.FC<Props> = props => {
  const { onSubmit, onClose, contactsIds } = props

  const triggerElement = useRef<HTMLDivElement>(null)

  const contactsQuery = useInfiniteMinimalContacts({
    contacts: contactsIds,
    showSecondaryContacts: true,
    limit: 20,
  })

  const contacts = contactsQuery.data?.pages.flatMap(page => page.contacts)

  const [username, setUsername] = useState('')

  const handleScroll = useScroll({
    triggerElement,
    isLoadingMore: contactsQuery.isLoading,
    hasMore: contactsQuery.hasNextPage,
    loadMore: contactsQuery.fetchNextPage,
  })

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    onSubmit(username)
  }

  if (contactsQuery.isLoading) {
    return <Transition message={'Loading your contacts...'} />
  }

  return (
    <div>
      <Dialog open={true} onClose={onClose}>
        <DialogTitle>
          <div style={{ display: 'flex', color: '#333' }}>
            <Text type="caption">Share Contacts</Text>
            <div style={{ marginLeft: 'auto' }}>
              <span className={styles.close} onClick={() => onClose?.()}>
                <Icon icon={'CLOSE'} color={'#6f8394'} size={18} />
              </span>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={styles.shareContainer}>
          {contactsQuery.error ? (
            <>
              <Text type="caption" color="danger">
                {'There was an error loading your contacts'}
              </Text>
              <Spacer space="x2" />
            </>
          ) : null}
          <div className={styles.shareBody}>
            <div className={styles.contacts}>
              <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                <HStack gap="x1" justify="flex-start">
                  <Input
                    placeholder="Username"
                    type="text"
                    value={username}
                    onChange={value => setUsername(value)}
                  />
                  <Button onClick="submitForm">Share</Button>
                </HStack>
              </form>
              <Spacer space="x2" />
              <Text type="body">{`Sharing ${contactsIds.length} Contacts`}</Text>
              <div className={styles.contactList} onScroll={handleScroll}>
                <List style={{ padding: 0 }}>
                  {contacts?.map(contact => (
                    <ListItem key={contact.id}>
                      <ListItemText
                        primary={
                          <Text type="caption">
                            {contact.firstName} {contact.lastName}
                          </Text>
                        }
                        disableTypography={true}
                      />
                    </ListItem>
                  ))}
                </List>
                {contactsQuery.hasNextPage && (
                  <div
                    ref={triggerElement}
                    style={{ background: 'transparent', boxShadow: 'none' }}
                  >
                    <CircularProgress />
                  </div>
                )}
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default ShareContact
